import urlModule from 'url';
export const urlEncode = window.encodeURIComponent;
export const urlDecode = window.decodeURIComponent;
export const urlParse = urlModule.parse;
export const urlFormat = urlModule.format;
export const urlResolve = urlModule.resolve;
